










import { Vue, Component } from 'vue-property-decorator';

import CustomerImportFailure from '@/componentsV2/templates/CustomerImportFailure/CustomerImportFailure.vue';
import { ECustomerImportSteps } from '../CustomerImportModal.vue';

@Component({
  components: {
    CustomerImportFailure
  }
})
export default class Error extends Vue {
  handleClose() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Customer Import Error`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Close" button`
    });

    this.$emit('customer-import-event', { type: 'closeModal' });
  }

  handleTryAgain() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Customer Import Error`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Try again" button`
    });

    this.$emit('customer-import-event', {
      type: 'goToStep',
      params: { goToStep: ECustomerImportSteps.IMPORT_IN_PROGRESS }
    });
  }
}
